<template>
  <div class="results-gallery__grid"
        ref="grid"
        v-bind:style="{'height': 46 + 'vh' }"
        v-bind:class="[grid, wallType, {'all-visible': activeColours.length === 0}]">

    <div v-for="(item, i) in resultsGrid" 
        :key="item + i"
        ref="gridBlock"
        :title="item.colourName"
        v-touch:tap="activate.bind(this, item)"
        v-bind:style="[{'backgroundColor': 'rgb('+ item.red + ',' + item.green + ',' + item.blue + ')'}, {'height': 2 + 'vh'}]"
        v-bind:class="['grid__block', {'active': activeColours.includes(convertToCompare(item)), 'primary': heroColor && heroColor.colourName === item.colourName }]">
    </div>
  </div>
</template>

<script>
import colorWall from '../../../assets/data/allColours.json'

export default {
  name: 'ColorGrid',
  props: ['wallColors', 'heroColor', 'colors', 'grid'],
  data() {
    return {
      resultsGrid: [],
      gridBlockHeight: 0,
      gridHeight: 500,
      activeColours: [],
      colorWall: colorWall
    }
  },
  computed: {
    wallType () {
      return this.$route.query.wall || 'large'
    },
    selectedColor: function() {
      return this.$store.state.selectedColor;
    },
  },
  mounted(){    
    if (this.currentPattern !== "white") {
      this.checkActiveColours()
    }

    this.setupWall()
    
  },
  methods: {
    setupWall(){
      for (var i = 0; i < this.wallColors.length; i ++) {
        this.resultsGrid.push(this.wallColors[i])
      }
      
      if (this.grid === 'small' || this.grid === 'large') {
        this.$nextTick(()=>{
          this.gridBlockHeight = this.$refs.gridBlock[0].clientWidth / 1.3 // keep block with design ratio
          this.gridHeight = Math.ceil(this.gridBlockHeight * 23) // define grid height

        })
      }
    },
    checkActiveColours() {
      if (this.heroColor) {
        this.activeColours.push(this.convertToCompare(this.heroColor));
      }

      if (this.colors && this.colors.length > 0) {
        for (var i = 0; i < this.colors.length; i ++) {
          this.activeColours.push(this.convertToCompare(this.colors[i]));
        }
      }
    },
    activate(item) {
      this.$store.commit('updateSelectedColor', item)
      this.$store.commit('isListOrGridView', 'grid')
      this.$router.push('/results');
    },
    convertToCompare(item) { // convert rgb values to string to compare
      return "" + item.red + item.green + item.blue
    }
  }
}
</script>
